import { useTranslation } from "react-i18next";
import { parseI18nMessage } from "@/lib/i18nMessage";

/**
 * Traduit un message produit par `i18nMessage` (typiquement un message d'erreur zod).
 * Un message qui n'est pas une clé connue est renvoyé tel quel.
 */
export const useTranslateMessage = () => {
  const { t, i18n } = useTranslation();

  return (message?: string): string | undefined => {
    if (!message) return message;
    const { key, values } = parseI18nMessage(message);
    // Clé construite à l'exécution (message zod), d'où l'appel non typé.
    return i18n.exists(key)
      ? (t as (key: string, options?: object) => string)(key, values)
      : message;
  };
};
